import script from "./TressAccordionNoIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./TressAccordionNoIcon.vue?vue&type=script&lang=ts&setup=true"

import "./TressAccordionNoIcon.vue?vue&type=style&index=0&id=1031fe2c&lang=scss"

const __exports__ = script;

export default __exports__